import { CalendarDayPartition } from '../../../data-model/schema/databases/site-transactions-archive/design/Partitions';
import { CalendarMonthPartition } from '../types/Partition';

export const getMonth = (
  partition: CalendarMonthPartition | CalendarDayPartition
): number => {
  return partition[2];
};
